import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  NavLink as Link,
  withRouter
} from 'react-router-dom';
import {
  AgendaDateAsDay,
  AgendaDateAsShortDate
} from '../../../module/Dates';
import {
  resolveParams
} from '../../../module/RoutingUtils';
import './AgendaNav.css';

class AgendaNav extends Component {
  render() {
    const {dates} = this.props;
    return (
      <nav className="AgendaNav">
        {dates.map(day => {
          const path = resolveParams({
            path: this.props.match.path.replace(":date?", day),
            params: this.props.match.params,
          });
          return (
            <Link to={path} key={day} className="AgendaNavItem" activeClassName="active">
              {AgendaDateAsDay(day)}
              <br/>
              {AgendaDateAsShortDate(day)}
            </Link>
          );
        })}
      </nav>
    );
  }
}

AgendaNav.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default withRouter(AgendaNav);



// WEBPACK FOOTER //
// ./src/component/pages/Agenda/AgendaNav.js